<template><div><h1 id="eloqua-ereignis-fur-bounces" tabindex="-1"><a class="header-anchor" href="#eloqua-ereignis-fur-bounces"><span>Eloqua Ereignis für Bounces</span></a></h1>
<p>Eloqua Ereignis für Bounces — Ereignis für Bounces</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>E-Mail Bounces werden als Refusé-Ereignis auf das versendete Initial-Ereignis erfasst. Falls jedoch kein Initial-Ereignis vorhanden ist oder nicht gefunden wird, wird das Ereignis welcher in dieser Tabelle definiert ist erfasst. Es kann nur ein Ereignis für solche Fälle definiert werden.</p>
<p>Pfad: <code v-pre>Datenaustausch → Tabellen → Eloqua → Eloqua E-Mailversand Zuordnung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Ereignis</dt>
<dd>Ereignis</dd>
<dt>Position</dt>
<dd>Ereignisposition</dd>
<dt>Ereignisbezeichnung</dt>
<dd>Ereignisbezeichnung (read-only)</dd>
<dt>Ereignisstatus</dt>
<dd>Ereignisstatus</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/schnittstelle/eloqua.html" title="3. Eloqua (Marketing Automation)">Eloqua</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.EloquaEmailVersandZuordnung.html" title="Eloqua E-Mailversand Zuordnung">Eloqua E-Mailversand Zuordnung</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.EloquaEreigniswahlNachText.html" title="Eloqua Ereigniswahl nach Text">Ereigniswahl nach Text</RouteLink></p>
</div></template>


